/* ============================================================================
   CircleDrops — Defects accordion: defect-photo Fancybox opener (externalized)
   ----------------------------------------------------------------------------
   Save this file as:  assets/defects.js
   Loaded from snippets/defects.liquid with:
     <script src="{{ 'defects.js' | asset_url }}" defer></script>

   The inline <script> this replaces had NO Liquid in it, so nothing needs to be
   bridged. It uses a delegated document click listener, so it covers BOTH copies
   of the snippet on the PDP (desktop + tablet/mobile) and survives DOM swaps
   (variant change / quickshop). The original global guard
   (window.__cdDefectFancyboxInstalled) is preserved, so even though the snippet
   renders twice — each emitting this deferred tag — the handler binds only once.

   Shopify does NOT render Liquid inside asset .js files; this file is pure JS.
   It still relies on the theme globals Fancybox / loadRes / new_css /
   window.filepaths exactly as before (resolved at click time), with a
   new-tab fallback if any are unavailable.
   ========================================================================== */

(function () {
  'use strict';
  if (window.__cdDefectFancyboxInstalled) return;
  window.__cdDefectFancyboxInstalled = true;

  function buildItems(block) {
    var anchors = Array.prototype.slice.call(
      block.querySelectorAll('.cd-defect-images__item')
    );
    var items = anchors.map(function (a) {
      var img = a.querySelector('img');
      return {
        src: a.getAttribute('href'),
        type: 'image',
        thumb: img ? (img.getAttribute('src') || '') : '',
        caption: a.getAttribute('data-caption') || ''
      };
    });
    return { anchors: anchors, items: items };
  }

  function openGallery(items, startIndex) {
    if (typeof Fancybox === 'undefined') return false;
    try {
      new Fancybox(items, {
        startIndex: startIndex || 0,
        Carousel: { Panzoom: { touch: true } },
        on: {
          ready: function (fb) {
            // Show the thumbnail strip when there's more than one
            // photo — mirrors the theme's product-gallery behaviour.
            try {
              if (fb.plugins && fb.plugins.Thumbs && fb.items && fb.items.length > 1) {
                if (fb.plugins.Thumbs.state === 'hidden') {
                  fb.plugins.Thumbs.show();
                }
              }
            } catch (err) { /* no-op */ }
          }
        }
      });
      return true;
    } catch (err) {
      return false;
    }
  }

  document.addEventListener('click', function (e) {
    var anchor = e.target.closest ? e.target.closest('.cd-defect-images__item') : null;
    if (!anchor) return;

    var block = anchor.closest('.cd-defects-block');
    if (!block) return;

    e.preventDefault();

    var built = buildItems(block);
    if (!built.items.length) {
      // Nothing to show — let the link behave normally.
      window.open(anchor.getAttribute('href'), '_blank', 'noopener');
      return;
    }
    var startIndex = built.anchors.indexOf(anchor);
    if (startIndex < 0) startIndex = 0;

    // Fancybox already loaded → open immediately.
    if (typeof Fancybox !== 'undefined') {
      if (openGallery(built.items, startIndex)) return;
    }

    // Otherwise lazy-load it through the theme's own loader.
    if (typeof loadRes === 'function' && window.filepaths && window.filepaths['plugin_fancybox_js']) {
      if (typeof new_css === 'function' && window.filepaths['async_fancybox_css']) {
        new_css('css-fancybox', window.filepaths['async_fancybox_css']);
      }
      loadRes(window.filepaths['plugin_fancybox_js'], function () {
        if (!openGallery(built.items, startIndex)) {
          window.open(anchor.getAttribute('href'), '_blank', 'noopener');
        }
      }, 'fancybox-loaded');
      return;
    }

    // Last-resort fallback.
    window.open(anchor.getAttribute('href'), '_blank', 'noopener');
  }, false);
})();